<script>
export default {
  name: "AppFooter",
};
</script>

<template>
  <transition name="fade">
    <footer class="app-footer">
      <v-container>
        <v-row class="text-center text-md-left">
          <!-- Kontakt -->
          <v-col cols="12" sm="6" md="4" class="mb-4 text-center">
            <h4 class="text-h6 font-weight-medium mb-2">
              {{ $t("footer.contact") }}
            </h4>
            <p class="mb-1"><strong>SÖFRE</strong></p>
            <a
              href="mailto:info@sofre.se"
              class="text-decoration-none text-primary mb-1"
              >info@sofre.se</a
            >
            <p class="mb-1">Org.nr. 802408-7523</p>
          </v-col>

          <!-- Frågor om hemsidan -->
          <v-col cols="12" sm="6" md="4" class="mb-4 text-center">
            <h4 class="text-h6 font-weight-medium mb-2">
              {{ $t("footer.support") }}
            </h4>
            <p class="mb-1 text-caption">{{ $t("footer.questionContact") }}</p>
            <a
              href="mailto:axel.hagerback@sofre.se"
              class="text-decoration-none text-primary"
              >axel.hagerback@sofre.se</a
            >
            <!-- Du kan lägga till fler kontaktuppgifter här om du vill -->
          </v-col>

          <!-- Adress -->
          <v-col cols="12" sm="6" md="4" class="mb-4 text-center">
            <h4 class="text-h6 font-weight-medium mb-2">
              {{ $t("footer.address") }}
            </h4>
            <p class="mb-1">Alfred Nobels Allé 9</p>
            <p class="mb-1">141 52 Huddinge</p>
            <p class="mb-1">
              <a
                href="https://www.sofre.se/"
                target="_blank"
                rel="noopener"
                class="text-decoration-none text-primary"
              >
                www.sofre.se
              </a>
            </p>
          </v-col>
          <v-col class="pt-10">
            <h3 class="text-center">
              {{ $t("common.madeBy") }}: Axel Hägerbäck
            </h3>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </transition>
</template>

<style scoped>
.app-footer {
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  padding: 32px 16px;
  font-size: 0.9rem;
  color: #333;
}
</style>
